module.exports = __webpack_public_path__ + "static/Q1_2023_Announcement_Financial_Results-09babaaad353be8bd0be92e2b815b5da.pdf";